import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UpdateOccasionRequest {
  title: string;
  date: string;
}

interface UpdateOccasionResponse {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  date: string;
  created_at: string;
  updated_at: string;
}

export function useUpdateOccasion(relationshipId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      occasionId,
      data,
    }: {
      occasionId: string;
      data: UpdateOccasionRequest;
    }) => {
      const response = await api
        .patch(`relationships/${relationshipId}/occasions/${occasionId}`, {
          json: data,
        })
        .json<UpdateOccasionResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.relationship.byId(relationshipId),
      });
    },
  });
}
